/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2023-10-26 15:10:50
 * @LastEditTime: 2023-11-14 16:36:47
 * @LastEditors: WangYuhan
 */
import Axios from 'axios';

import { getCookie } from '@/utils/cookie';
import JSON_BIG from 'json-bigint';

// 创建axios实例（用于日志和错误上报）
const service = Axios.create({
  baseURL: process.env.VUE_APP_BASIC_API1,
  timeout: 600000,
  transformResponse: data => {
    try {
      return JSON_BIG.parse(data);
    } catch (err) {
      return JSON.parse(data);
    }
  },
});
service.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';

// 添加响应拦截器，确保日志上报错误不会抛出异常
service.interceptors.response.use(
  response => response.data,
  error => {
    // 静默处理日志上报的网络错误，避免影响业务流程
    if (process.env.NODE_ENV === 'development') {
      console.warn('[data.js] 日志/错误上报请求失败:', error.message);
    }
    // 返回一个 rejected promise，由具体函数的 catch 处理
    return Promise.reject(error);
  },
);
// 埋点信息上报 - 安全包装，确保日志报错不影响业务流程
export function logReport(params) {
  return service.post(`/rest/logReport`, formatEvent(params)).catch(error => {
    // 静默处理日志上报错误，不影响业务流程
    if (process.env.NODE_ENV === 'development') {
      console.warn('[logReport] 日志上报失败:', error.message);
    }
    // 返回 resolved promise，确保不会中断业务流程
    return Promise.resolve({ code: -1, message: '日志上报失败' });
  });
}

// 错误信息上报 - 安全包装，确保日志报错不影响业务流程
export function errorReport(params) {
  return service.post(`/rest/errorReport`, formatError(params)).catch(error => {
    // 静默处理错误上报失败，不影响业务流程
    if (process.env.NODE_ENV === 'development') {
      console.warn('[errorReport] 错误上报失败:', error.message);
    }
    // 返回 resolved promise，确保不会中断业务流程
    return Promise.resolve({ code: -1, message: '错误上报失败' });
  });
}

function formatEvent(obj) {
  let tex = '客户端:\n';
  let userInfo = {};
  if (window.localStorage.userInfo) {
    userInfo = window.localStorage.userInfo && JSON.parse(window.localStorage.userInfo);
    if (userInfo.menuRoleInfos) {
      delete userInfo['menuRoleInfos'];
    }
  }
  let logs = [].concat(window.localStorage.logs ? JSON.parse(window.localStorage.logs) : []);
  logs = logs.splice(logs.length - 20, 20);

  const newObject = Object.assign({}, obj, {
    token: getCookie('oss-token') ? getCookie('oss-token') : '',
    appVersion: window.navigator.appVersion,
    vendor: window.navigator.vendor,
    userInfo: userInfo,
    logs: logs,
  });
  const configList = ['baseURL', 'data', 'headers', 'method', 'url', 'designation', 'params'];
  for (const texKey in newObject) {
    if (
      [
        'data',
        'token',
        'userInfo',
        'appVersion',
        'vendor',
        'url',
        'designation',
        'params',
      ].includes(texKey)
    ) {
      tex += `${texKey}: ${JSON.stringify(newObject[texKey])
        .replaceAll(',', ',\n  ')
        .replaceAll('{', '{\n  ')
        .replaceAll('}', '\n}')},\n`;
      tex += `------------------------------split------------------------------\n`;
    }
    if (['logs'].includes(texKey)) {
      tex += `${texKey}: [\n`;
      for (const texKeyKey in newObject[texKey]) {
        tex += `   ${JSON.stringify(newObject[texKey][texKeyKey])},\n`;
      }
      tex += ']\n';
      tex += `------------------------------split------------------------------\n`;
    }
    if (['config', 'response'].includes(texKey)) {
      tex += `${texKey}: `;
      for (const texKeyKey in newObject[texKey]) {
        if (!configList.includes(texKeyKey)) {
          delete newObject[texKey][texKeyKey];
        }
        if (texKeyKey === 'headers') {
          newObject[texKey]['groupId'] = newObject[texKey][texKeyKey]['groupId'];
          delete newObject[texKey][texKeyKey];
        }
      }
      tex += JSON.stringify(newObject[texKey])
        .replaceAll(',', ',\n  ')
        .replaceAll('{', '{\n  ')
        .replaceAll('}', '\n}');
      tex += ',\n';
      tex += `------------------------------split------------------------------\n`;
    }
  }
  return tex;
}

function formatError(obj) {
  let tex = '客户端:\n';
  let logs = [].concat(window.localStorage.logs ? JSON.parse(window.localStorage.logs) : []);
  logs = logs.splice(logs.length - 20, 20);
  let userInfo = {};
  if (window.localStorage.userInfo) {
    userInfo = window.localStorage.userInfo && JSON.parse(window.localStorage.userInfo);
    if (userInfo.menuRoleInfos) {
      delete userInfo['menuRoleInfos'];
    }
  }
  const newObject = Object.assign(obj, {
    token: getCookie('oss-token') ? getCookie('oss-token') : '',
    appVersion: window.navigator.appVersion,
    vendor: window.navigator.vendor,
    userInfo: userInfo,
    logs: logs,
  });
  const configList = ['baseURL', 'data', 'headers', 'method', 'url'];
  for (const texKey in newObject) {
    if (['data', 'token', 'userInfo', 'appVersion', 'vendor'].includes(texKey)) {
      tex += `${texKey}: ${JSON.stringify(newObject[texKey])
        .replaceAll(',', ',\n  ')
        .replaceAll('{', '{\n  ')
        .replaceAll('}', '\n}')},\n`;
      tex += `------------------------------split------------------------------\n`;
    }
    if (['logs'].includes(texKey)) {
      tex += `${texKey}: [\n`;
      for (const texKeyKey in newObject[texKey]) {
        tex += `   ${JSON.stringify(newObject[texKey][texKeyKey])},\n`;
      }
      tex += ']\n';
      tex += `------------------------------split------------------------------\n`;
    }
    if (['config', 'response'].includes(texKey)) {
      tex += `${texKey}: `;
      for (const texKeyKey in newObject[texKey]) {
        if (!configList.includes(texKeyKey)) {
          delete newObject[texKey][texKeyKey];
        }
        if (texKeyKey === 'headers') {
          newObject[texKey]['groupId'] = newObject[texKey][texKeyKey]['groupId'];
          delete newObject[texKey][texKeyKey];
        }
      }
      tex += JSON.stringify(newObject[texKey])
        .replaceAll(',', ',\n  ')
        .replaceAll('{', '{\n  ')
        .replaceAll('}', '\n}');
      tex += ',\n';
      tex += `------------------------------split------------------------------\n`;
    }
  }
  return tex;
}
